export const START_LOADING      = 'START_LOADING';
export const ADD_BILLS          = 'ADD_BILLS';
export const SET_BILLS          = 'SET_BILLS';
export const SET_END_REACHED    = 'SET_END_REACHED';
export const SET_REFUND         = 'SET_REFUND';
export const SET_REFUND_SUM     = 'SET_REFUND_SUM';
export const SET_BILL_REFUND    = 'SET_BILL_REFUND';
export const SET_PAY_SUM        = 'SET_PAY_SUM';
export const ADD_BILL_AT_START  = 'ADD_BILL_AT_START';
export const SET_TODAY_SUM      = 'SET_TODAY_SUM';



// WEBPACK FOOTER //
// ./src/js/store/bills/actionTypes.js